// extracted by mini-css-extract-plugin
export var dropdownIcon = "_md-6";
export var imgContainer = "_md-3";
export var menuIcon = "_md-5";
export var pillWrapper = "_md-2";
export var pillsContainer = "_md-1";
export var subscriptionCard = "_md-0";
export var subscriptionLogo = "_md-4";